import { ScenarioFacilityCapacityBase } from './base/scenario-facility-capacity-base';

export class ScenarioFacilityCapacity extends ScenarioFacilityCapacityBase { }